<template>
    <div class="about-contacts">
        <div v-if="!pickupPoints.length">
            В выбранном населённом пункте нет доступных пунтов выдачи.
        </div>
        <yandex-map
            v-show="viewMap"
            v-if="pickupPoints.length || stores.length"
            :settings="mapSettings"
            :coords="center"
            :zoom="zoom"
            :controls="['zoomControl', 'fullscreenControl']"
            :cluster-options="clusterOptions"
            @map-was-initialized="setMap"
            style="width: 100%; height: 600px;">
            <ymap-marker
                v-for="(stores, index) in filteredStores"
                :key="stores.id"
                :marker-id="index"
                marker-type="placemark"
                :coords="[stores.lng, stores.lat]"
                :hint-content="stores.name"
                :icon="markerIconStore"
                :properties="{
                    iconContent: index + 1,
                    hintContent: stores.address
                }"
                :callbacks="callbacks(index, 'store')"
                cluster-name="1"
            ></ymap-marker>
            <ymap-marker
                v-for="(pickupPoint, index) in filteredPickupPoints"
                :key="pickupPoint.id"
                :marker-id="index"
                marker-type="placemark"
                :coords="[pickupPoint.lng, pickupPoint.lat]"
                :hint-content="pickupPoint.name"
                :icon="markerIconPickupPoint"
                :properties="{
                    iconContent: filteredStores.length + index + 1,
                    hintContent: pickupPoint.address
                }"
                :callbacks="callbacks(index, 'pickupPoint')"
                cluster-name="1"
            ></ymap-marker>
        </yandex-map>

        <div v-show="viewList"
             class="nav-container d-flex flex-column"
             :class="{ 'absolute': !this.$q.platform.is.mobile }">
            <div class="desktop-category-tags px-3">
                <span class="tag-item cursor-pointer"
                      :class="{ 'selected': filters.indexOf('stores') !== -1 }"
                      @click="toggleFilter('stores')">Магазины К-С</span>
                <span class="tag-item cursor-pointer"
                      :class="{ 'selected': filters.indexOf('pickup_points') !== -1 }"
                      @click="toggleFilter('pickup_points')">Пункты партнеров</span>
            </div>

            <ol v-if="filteredPickupPoints.length || filteredStores.length" class="nav">
                <li v-for="(store, index) in filteredStores" class="nav-item" :id="'store-' + index + '-details'">
                    <span class="nav-link" @click="toggleStore(index)">
                        {{ store.name }}
                    </span>
                    <div v-if="(selectedType === 'stores') && (selectedIndex === index)">
                        <span>{{ store.address }}</span>
                        <span>
                                <a :href="'tel: ' + store.contact_phone_number" class="link">{{ store.contact_phone_number }}</a></span>
                        <span>{{ store.work_time }}</span>
                    </div>
                </li>
                <li v-for="(pickupPoint, index) in filteredPickupPoints" class="nav-item" :id="'pickup-point-' + index + '-details'">
                    <span class="nav-link" @click="togglePickupPoint(index)">
                        {{ pickupPoint.name }}
                    </span>
                    <div v-if="(selectedType === 'pickupPoints') && (selectedIndex === index)">
                        <span>{{ pickupPoint.address }}</span>
                        <span>
                                <a :href="'tel: ' + pickupPoint.contact_phone_number" class="link">{{ pickupPoint.contact_phone_number }}</a></span>
                        <span>{{ pickupPoint.work_time }}</span>
                    </div>
                </li>
            </ol>
        </div>
<!--        <ol v-show="viewList" v-if="pickupPoints.length" class="nav nav-shops" id="shops-accordion">
            <li v-for="(pickupPoint, index) in pickupPoints" class="nav-item"
                :id="'pickup-point-' + index + '-details'">
                    <span class="nav-link" @click.prevent="togglePickupPoint(index)">
                        {{ pickupPoint.name }}
                    </span>
                <div v-if="selected === index">
                    <span>{{ pickupPoint.address }}</span>
                    <a :href="'tel: ' + pickupPoint.contact_phone_number"
                       class="link mb-2">{{ pickupPoint.contact_phone_number }}</a>
                    <span>{{ pickupPoint.work_time }}</span>
                </div>
            </li>
        </ol>-->
    </div>
</template>

<script>
import {yandexMap, ymapMarker} from "vue-yandex-maps";
import {mapState} from "vuex";
import _ from "lodash";

export default {
    components: {yandexMap, ymapMarker},
    data() {
        return {
            map: null,
            center: [0, 0],
            zoom: 12,
            selectedType: null,
            selectedIndex: null,
            viewMap: true,
            viewList: !this.$q.platform.is.mobile,
            filters: [],
            clusterOptions: {
                1: {
                    clusterDisableClickZoom: false,
                    clusterOpenBalloonOnClick: true,
                },
            },
            markerIconStore: {
                layout: 'default#image',
                imageHref: '/img/svg/map_store.svg',
                imageSize: [40, 40],
                imageOffset: [-20, -40]
            },
            markerIconPickupPoint: {
                layout: 'default#image',
                imageHref: '/img/svg/map_pickup.svg',
                imageSize: [40, 40],
                imageOffset: [-20, -40]
            }
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        pickupPoints() {
            this.update();
        },
        map() {
            this.update();
        }
    },
    methods: {
        init() {
            let _this = this;

            axios.get('/deliveries/pickup-points')
                .then(response => {
                    _this.$store.commit('delivery/setPickupPoints', response.data.pickupPoints);
                    _this.$store.commit('delivery/setStores', response.data.stores);
                })
        },

        update() {
            let _this = this;

            _this.clearSelected();

            if ((_this.pickupPoints.length || _this.stores.length) && _this.map) {
                this.$nextTick(function () {
                    setTimeout(function () {
                        let bounds = _this.map.geoObjects.getBounds();
                        if (bounds) {
                            _this.map.setBounds(bounds, {checkZoomRange:true});
                        }
                    }, 200);
                });
            }
        },
        clearSelected () {
            this.selectedType = null;
            this.selectedIndex = null;
        },
        toggleStore (index) {
            if ((this.selectedType === 'stores') && (this.selectedIndex === index)) {
                this.selectedType = null;
                this.selectedIndex = null;
            } else {
                this.selectedType = 'stores';
                this.selectedIndex = index;
            }

            this.map.setZoom(17);
            this.map.panTo([this.stores[index].lng, this.stores[index].lat], {flying: true, duration: 1000});
        },
        togglePickupPoint (index) {
            if ((this.selectedType === 'pickupPoints') && (this.selectedIndex === index)) {
                this.selectedType = null;
                this.selectedIndex = null;
            } else {
                this.selectedType = 'pickupPoints';
                this.selectedIndex = index;
            }

            this.map.setZoom(17);
            this.map.panTo([this.pickupPoints[index].lng, this.pickupPoints[index].lat], {flying: true, duration: 1000});
        },
        setMap(map) {
            this.map = map;
        },
        callbacks(index, type) {
            let _this = this;

            return {
                click: function () {
                    if (type === 'store') {
                        document.getElementById('store-' + index + '-details').scrollIntoView();

                        _this.toggleStore(index);
                    } else {
                        document.getElementById('pickup-point-' + index + '-details').scrollIntoView();

                        _this.togglePickupPoint(index);
                    }
                }
            }
        },
        selectCity() {
            this.$root.selectCity();
        },
        toggleViewMap() {
            this.viewMap = true;
            this.viewList = false;
        },
        toggleViewList() {
            this.viewMap = false;
            this.viewList = true;
        },
        toggleFilter (filter) {
            let index = this.filters.indexOf(filter);

            if (index !== -1) {
                this.filters.splice(index, 1);
            } else {
                this.filters.push(filter);
            }
        },
    },
    computed: {
        ...mapState('geo', [
            'location',
        ]),
        ...mapState('delivery', [
            'pickupPoints',
            'stores',
            'mapSettings',
        ]),
        cityLabel() {
            return this.location.city
                ? this.location.city.type_short + '. ' + this.location.city.name
                : '';
        },
        pickupPointsCenter() {
            if (!this.pickupPoints.length && !this.stores.count) {
                return [54.989342, 73.368212];
            }

            return [
                (_.sumBy(this.pickupPoints, 'lng') + _.sumBy(this.stores, 'lng')) / (this.pickupPoints.length + this.stores.length),
                (_.sumBy(this.pickupPoints, 'lat') + _.sumBy(this.stores, 'lat')) / (this.pickupPoints.length + this.stores.length),
            ];
        },
        filteredStores () {
            if (!this.filters.length || (this.filters.indexOf('stores') !== -1)) {
                return this.stores;
            }

            return [];
        },
        filteredPickupPoints () {
            if (!this.filters.length || (this.filters.indexOf('pickup_points') !== -1)) {
                return this.pickupPoints.filter(pickupPoint => pickupPoint.delivery_service_id !== 1);
            }

            return [];
        }
    }
}
</script>
